import type { IntlKey } from 'locales';
import type { FC } from 'react';
import { useIntl } from 'react-intl';

interface ListItemProps {
  label: IntlKey;
  value: string;
}

export const ListItem: FC<ListItemProps> = ({ label, value }) => {
  const { formatMessage } = useIntl();
  return (
    <li className="list-group-item border-secondary d-flex justify-content-between px-0">
      <div className="text-secondary text-nowrap">{formatMessage({ id: label })}</div>
      <div className="text-primary text-truncate ms-4" title={value}>
        {value}
      </div>
    </li>
  );
};
